import { Observable } from 'rxjs';
import { ICustomerDisplayDevice } from './ICustomerDisplayDevice';
import { ICustomerDisplaySessionDelegate } from './ICustomerDisplaySessionDelegate';
import { ICustomerDisplaySession } from './ICustomerDisplaySession';

export abstract class ICustomerDisplayProvider {
  abstract turnOn(): Promise<void>;

  abstract turnOff(): Promise<void>;

  abstract get providerId(): string;

  abstract initialize(delegate: ICustomerDisplaySessionDelegate): Promise<void>;

  abstract get devices(): Observable<ICustomerDisplayDevice[]>;

  /**
   * Start only the eager discoveries (built-in/in-app displays). Cheap and
   * always safe to run — used at turnOn() regardless of whether any display is
   * saved, so the built-in secondary display never gets stuck mirroring.
   */
  abstract startEagerDiscoveries(): void;

  abstract startDeviceDiscovery(): void;

  abstract stopDeviceDiscovery(): void;

  abstract connect(device: ICustomerDisplayDevice): Promise<void>;

  abstract disconnect(device: ICustomerDisplayDevice, session: ICustomerDisplaySession | undefined): Promise<void>;
}
